var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9a9da2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 2.5c-4.14214 0-7.5 3.35786-7.5 7.5 0 4.1421 3.35787 7.5 7.5 7.5 4.1421 0 7.5-3.3579 7.5-7.5 0-4.14214-3.3579-7.5-7.5-7.5z",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.05859 9.67037v3.24633m2.50982-4.54485v4.54485m3.76469 0s0-2.0777 0-3.24633c0-1.94778-2.6353-1.753-3.76472-.2597",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.08317 7.91732c.23012 0 .41667-.18655.41667-.41667s-.18655-.41667-.41667-.41667-.41667.18655-.41667.41667.18655.41667.41667.41667z",
    fill: "#9a9da2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGrey);
export default __webpack_public_path__ + "static/media/linkedin_grey.19879876dee2aa6644bd7883b41fa153.svg";
export { ForwardRef as ReactComponent };